import RequestStatus from "../model/RequestStatus";
import {ProgramMetadataResponse} from "../model/ProgramMetadata";
import QueryProductInfo from "src/model/QueryProduct";
import QueryProduct from "src/model/QueryProduct";

export const PROGRAM_METADATA_QUERY_START = 'PROGRAM_METADATA_QUERY_START';
export const PROGRAM_METADATA_QUERY_SUCCESS = 'PROGRAM_METADATA_QUERY_SUCCESS';
export const PROGRAM_METADATA_QUERY_FAILED = 'PROGRAM_METADATA_QUERY_FAILED';

export interface ProgramMetadataQueryStartAction {
    readonly type: string,
    readonly requestStatus: RequestStatus,
    readonly countryCode: string,
    readonly queryProduct: QueryProduct,
}

export const setProgramMetadataQueryStart = (countryCode: string, queryProduct: QueryProduct): ProgramMetadataQueryStartAction => ({
    type: PROGRAM_METADATA_QUERY_START,
    requestStatus: RequestStatus.LOADING,
    countryCode: countryCode,
    queryProduct: queryProduct,
});

export interface GetProgramMetadataQueryComplete {
    readonly type: string;
    readonly requestStatus: RequestStatus;
    readonly programMetadata: any;
}

export const getProgramMetadataQuerySuccessAction = (response: ProgramMetadataResponse): GetProgramMetadataQueryComplete => ({
    type: PROGRAM_METADATA_QUERY_SUCCESS,
    requestStatus: RequestStatus.SUCCESS,
    programMetadata: response
});

export const getProgramMetadataQueryFailedAction = (): GetProgramMetadataQueryComplete => ({
    type: PROGRAM_METADATA_QUERY_FAILED,
    requestStatus: RequestStatus.ERROR,
    programMetadata: null
});